import React, { useEffect } from 'react';
import '../../styles/ServicePage.css';

const ImpressumPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="service-page">
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <h1>Impressum</h1>
            <p>Gesetzliche Angaben zum Webseitenbetreiber</p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <h2 className="service-section-title">Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</h2>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Betreiber der Website</h3>
              <p>
                <strong>IB Neubaur GmbH</strong><br />
                Fachplanung Elektrotechnik
              </p>

              <p><strong>Hauptstandort:</strong><br />
              Nelkenweg 6a<br />
              86641 Rain am Lech</p>

              <p><strong>Standort Ingolstadt:</strong><br />
              Florian-Geyer-Straße 7<br />
              85055 Ingolstadt</p>

              <p><strong>Standort Marxheim:</strong><br />
              Bayernstraße 20<br />
              86688 Marxheim</p>

              <p><strong>Vertreten durch:</strong><br />
              Geschäftsführer: Gerhard Neubaur</p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Kontakt</h3>
              <p>Telefon: +49 (0) 90 90 - 95 900-10<br />
              E-Mail: <a href="mailto:info@neubaur-gmbh.de">info@neubaur-gmbh.de</a></p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Registereintrag</h3>
              <p>
                Eingetragen im Handelsregister.<br />
                Registergericht: Amtsgericht Augsburg<br />
                Registernummer: HRB 17175
              </p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Umsatzsteuer-ID</h3>
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
              DE 201 857 569</p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Berufsbezeichnung und berufsrechtliche Regelungen</h3>
              <p>
                Berufsbezeichnung: Ingenieur<br />
                Verliehen in: Bundesrepublik Deutschland
              </p>
              <p>
                <strong>Zuständige Kammer:</strong><br />
                Bayerische Ingenieurekammer-Bau<br />
                Schloßschmidstraße 3<br />
                80639 München<br />
                Web: <a href="https://www.bayika.de" target="_blank" rel="noopener noreferrer">www.bayika.de</a>
              </p>
              <p>
                <strong>Es gelten folgende berufsrechtliche Regelungen:</strong>
              </p>
              <ul>
                <li>Bayerisches Baukammerngesetz (BayBauKaG)</li>
                <li>Berufsordnung der Bayerischen Ingenieurekammer-Bau</li>
                <li>Honorarordnung für Architekten und Ingenieure (HOAI)</li>
              </ul>
              <p>
                Diese Regelungen sind einsehbar unter:{' '}
                <a href="https://www.bayika.de" target="_blank" rel="noopener noreferrer">
                  www.bayika.de
                </a>
              </p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Berufshaftpflichtversicherung</h3>
              <p>
                Die Angaben zur Berufshaftpflichtversicherung nach § 2 DL-InfoV
                (Dienstleistungs-Informationspflichten-Verordnung) werden auf Anfrage
                mitgeteilt. Bitte wenden Sie sich hierzu an{' '}
                <a href="mailto:info@neubaur-gmbh.de">info@neubaur-gmbh.de</a>.
              </p>
              <p>
                <strong>Räumlicher Geltungsbereich:</strong> Deutschland / Europa.
              </p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
              <p>
                Gerhard Neubaur<br />
                IB Neubaur GmbH<br />
                Nelkenweg 6a<br />
                86641 Rain am Lech
              </p>
            </div>
          </section>

          <section className="service-section">
            <h2 className="service-section-title">EU-Streitschlichtung</h2>
            <div style={{ marginBottom: '2rem' }}>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
                bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                  https://ec.europa.eu/consumers/odr
                </a>
                .
              </p>
              <p>
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </div>

            <h3>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h3>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="service-section">
            <h2 className="service-section-title">Haftungsausschluss</h2>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Haftung für Inhalte</h3>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind
                wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
                fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                rechtswidrige Tätigkeit hinweisen.
              </p>
              <p>
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach
                den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung
                ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
                Inhalte umgehend entfernen.
              </p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Haftung für Links</h3>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
                keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
                Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
                Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
                zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
                Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>
              <p>
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
                konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden
                von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Urheberrecht</h3>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
                Gebrauch gestattet.
              </p>
              <p>
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden
                die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als
                solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
                aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
                von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3>Bildnachweise</h3>
              <p>
                Die auf dieser Website verwendeten Bilder, Grafiken und Videos stammen, soweit
                nicht anders gekennzeichnet, aus eigener Produktion oder wurden mit Zustimmung
                der jeweiligen Rechteinhaber verwendet.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
